import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { Device } from '../models/DeviceDTO.model';
import { CanSendSMSResponse } from '../models/sendSMS/CanSendSMSResponse';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  constructor(private httpService: HttpService) { }

   CanSendSMS(){
    
    return  this.httpService.get<CanSendSMSResponse>( ApiRoutesEnum.CanSendSMS).pipe(  tap((data) => {
      }) );
        
      }
}
